module.exports = __webpack_public_path__ + "img/categorie-quisommesnous-famille-boutrais-big.a389b1de.jpg";